module.exports = __webpack_public_path__ + "img/bsi.1a40e8d8.jpg";